import { call, put, select } from "redux-saga/effects";
import { addItemRequest, getItemsRequest, updateItemRequest } from "../../spItems/api";
import { VPORequirementsConditionsListName, VPOStatusQuestionnaireListName } from "src/api/config";
import { setEndQuestionarySuccess, setReturnQuestionarySuccess, setStatusQuestionarySuccess } from "../actions";
import { getDefaultSaga } from "./getDefaultSaga";
import { updateDefaultSaga } from "src/modules/spItems/sagas/updateDefaultSaga";
import { addDefaultSaga } from "src/modules/spItems/sagas/addDefaultSaga";
import { myTaskActionsListName } from "src/api/config/myTasksActions.config";
import { ContentTypeIdRequirement } from "../api/config";

export function* setReturnQuestionarySaga({ payload }: any) {
  try {
    if (payload) {

      const { 
        Title,
        ColumnID,
        // GroupID,
        FactoryID,
        Status,
        Month,
        Year,
        DirectoryData,
        GroupTitle,
      } = payload;

      let isAllCorrectActions = true,
          idStatusQuestionary = false;

      let GroupID = null;
      if(DirectoryData && DirectoryData.length > 0){
        let group = DirectoryData.filter((item: any) => item.Title == GroupTitle && item.FileRef.indexOf('/Lists/VPOColumns/'+ColumnID) >= 0);
        if(group && group.length > 0){
          GroupID = group[0].ID;
        }
      }

      const response: unknown = yield call<any>(getDefaultSaga, {
        listName: VPOStatusQuestionnaireListName,
        filtersType: 'and',
        filters: {
          ColumnID: '*' + ColumnID,
          GroupID: '*' + GroupID,
          FactoryID: '' + FactoryID,
          Month: '' + Month,
          Year: '' + Year
        },
      });

      if(
        response &&
        response.items &&
        response.items.length > 0
      ){
        response.items.map((item: any) => {
          idStatusQuestionary = item.ID;
        })
      }

      if(idStatusQuestionary){

        yield call<any>(getDefaultSaga, {
          listName: VPOStatusQuestionnaireListName,
          filters: {
            ID: idStatusQuestionary
          },
        });

        yield call<any>(updateDefaultSaga, {
          listName: VPOStatusQuestionnaireListName,
          body: {
            ID: idStatusQuestionary,
            Status: 1,
            IsError: false,
            AuthorEnd: null
          }
        })
      }

      yield put(setReturnQuestionarySuccess({
        isAllCorrectActions
      }))

      return response;

    }
  } catch (error) {
    console.log(error);
  }
}
